module.exports = __webpack_public_path__ + "media/img/frontend_application/no-photo-venue-9eca56ae8dbc3b4d986bfac095e764c4.jpg";